/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Refund_Date_LabelInputs */

const vi_customer_refund_date_label = /** @type {(inputs: Customer_Refund_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hoàn tiền`)
};

/**

* @param {Customer_Refund_Date_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_refund_date_label = /** @type {((inputs?: Customer_Refund_Date_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Refund_Date_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_refund_date_label(inputs)
});